import { useTranslation } from '../../../utils/useTranslation';
import { useShowBottomStub } from '../../dashboard/SearchAppPanelStub/hooks/useShowBottomStub';
import { Box } from '../../layout/Box';
import { DataTestId } from '../../layout/DataTestIdWrapper';
import { Spin } from '../../layout/Spin/Spin';
import { Typography } from '../../typography/Typography';
import { Wrapper } from './styles';

export const FileLoadingNotification = () => {
    const t = useTranslation();
    // вычисляем страницы где есть боттомбар, чтобы немного поднять плашку
    const hasFixedBottomTabbar = useShowBottomStub();

    return (
        <Wrapper
            bottom={{ xs: hasFixedBottomTabbar ? 8 : 4, md: 4 }}
            dataTestId={DataTestId.FILE_LOADING_NOTIFICATION}
        >
            <Typography variant="body" color="invert">
                {t('Файл формируется, не закрывайте вкладку')}
            </Typography>
            <Box ml="auto">
                <Spin size={24} color="var(--color-invert)" />
            </Box>
        </Wrapper>
    );
};
